import { createSignal, onMount } from "solid-js";
import { Grant } from "./MyGrants";
import { useSFetch } from "../hooks/sfetch";
import { User } from "../components/UserContextProvider";
import Text from "../components/Text";
import { For } from "solid-js";
import { useNavigate } from "@solidjs/router";
import { useRoleParser } from "../hooks/permissions";
import { formatDateTime } from "../services/dateFormat";


export default function Mybots() {

    const roles = ["Read", "Admin"];

    const navigate = useNavigate();
    const {parseRoles} = useRoleParser();
    const sfetch = useSFetch();
    const [bots, setBots] = createSignal<Grant[]>([]);
    const [allUsers, setAllUsers] = createSignal<User[]>([]);

    onMount(() => {
        sfetch('/api/GrantedUsers/GetMyBots')
            .then(data => setBots(data.value));

            sfetch('/api/User/Users')
            .then(data => setAllUsers(data.value));
    });

    return (
        <div class='dashboard-page'>
            <h1><Text val="MYBOTS"></Text></h1>
            <table class="sessiontable">
                <thead>
                    <tr>
                        <th><Text val="USERNAME"></Text></th>
                        <th><Text val="LEVEL"></Text></th>
                        <th><Text val="CREATEDAT"></Text></th>
                        <th><i class="fa-solid fa-pen-to-square"></i></th>
                    </tr>
                </thead>
                <tbody>
                    <For each={bots()}>
                        {(command) => (
                            <tr>
                                <td>{allUsers().filter((val, i) => val.id == command.botId)[0]?.username ?? "-"}</td>
                                <td>{parseRoles(command.level, roles).map((val, i) => 
                                <span>{roles[i]} {val ? <i class="fa-solid fa-check"></i> : <i class="fa-solid fa-xmark"></i>}</span>)}</td>
                                <td>{formatDateTime(command.createdAt)}</td>
                                <td><button onClick={() => navigate("/bot/" + command.id)}><i class="fa-solid fa-pen-to-square"></i></button></td>
                            </tr>
                        )}
                    </For>
                </tbody>
            </table>
        </div>
    )
}